import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'MTTF (Mean Time To Failure)',
  slug: 'mttf',
  definition: `MTTF measures the average time a system operates before it fails. It is used to predict reliability — a higher MTTF means the system tends to run longer between failures.

MTTF is most commonly applied to non-repairable components (like hard drives or light bulbs), but in software it is used more broadly to describe how long a service runs before encountering an issue that causes downtime.

In practice, MTTF helps teams understand failure patterns. If your MTTF is decreasing over time, something is introducing instability — a recent deploy, growing traffic, or degrading infrastructure.`,
  whyItMatters: `Tracking MTTF helps you spot reliability trends before they become critical. A steadily declining MTTF signals that your system is becoming less stable and needs attention.

MTTF also feeds into capacity planning and SLA calculations. If you know your average MTTF, you can estimate how much downtime to expect over a given period and whether your SLA targets are realistic.`,
  howUptrackHelps: `Uptrack logs every incident with precise timestamps, making it straightforward to calculate MTTF across your services. You can compare MTTF across different monitors to identify which services are least reliable.

By correlating MTTF changes with deployment timestamps, you can identify which changes introduced instability and address the root causes.`,
  formula: 'MTTF = Total Operating Time / Number of Failures',
  relatedTerms: [
    { name: 'MTBF', href: '/glossary/mtbf' },
    { name: 'MTTR', href: '/glossary/mttr' },
    { name: 'MTTD', href: '/glossary/mttd' },
    { name: 'Uptime', href: '/glossary/uptime' },
    { name: 'MTBF guide: meaning, formula, examples', href: '/blog/what-is-mtbf-meaning-formula' },
  ],
}

export const Route = createFileRoute('/_site/glossary/mttf')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
